"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.quotesMap = exports.regions = exports.allCountries = exports.languages = exports.currencies = void 0;
var getObjectKeys_1 = require("./utils/getObjectKeys");
/**
 * All available currencies in the BEMER universe.
 */
var currencies = {
    BRL: 'BRL',
    CAD: 'CAD',
    CHF: 'CHF',
    CZK: 'CZK',
    DKK: 'DKK',
    EUR: 'EUR',
    GBP: 'GBP',
    HUF: 'HUF',
    MYR: 'MYR',
    NOK: 'NOK',
    PLN: 'PLN',
    RON: 'RON',
    RSD: 'RSD',
    SEK: 'SEK',
    TWD: 'TWD',
    USD: 'USD',
    ZAR: 'ZAR',
};
exports.currencies = currencies;
/**
 * All available languages in the BEMER universe.
 */
var languages = {
    czech: {
        languageName: 'Čeština',
        languageCode: 'cs',
        quotes: { start: '„', end: '“' },
    },
    danish: {
        languageName: 'Dansk',
        languageCode: 'da',
        quotes: { start: '»', end: '«' },
    },
    dutch: {
        languageName: 'Nederlands',
        languageCode: 'nl',
        quotes: { start: '“', end: '”' },
    },
    english: {
        languageName: 'English',
        languageCode: 'en',
        quotes: { start: '“', end: '”' },
    },
    finnish: {
        languageName: 'Suomalainen',
        languageCode: 'fi',
        quotes: { start: '”', end: '”' },
    },
    french: {
        languageName: 'Français',
        languageCode: 'fr',
        quotes: { start: '«', end: '»' },
    },
    german: {
        languageName: 'Deutsch',
        languageCode: 'de',
        quotes: { start: '„', end: '“' },
    },
    hungary: {
        languageName: 'Magyarország',
        languageCode: 'hu',
        quotes: { start: '„', end: '“' },
    },
    italian: {
        languageName: 'Italiano',
        languageCode: 'it',
        quotes: { start: '«', end: '»' },
    },
    lithuanian: {
        languageName: 'Lietuviai',
        languageCode: 'lt',
        quotes: { start: '„', end: '“' },
    },
    malay: {
        languageName: 'မလေး',
        languageCode: 'my',
        quotes: { start: '“', end: '“' },
    },
    mandarin: {
        languageName: '普通话',
        languageCode: 'zh',
        quotes: { start: '“', end: '”' },
    },
    norwegian: {
        languageName: 'Norsk',
        languageCode: 'no',
        quotes: { start: '«', end: '»' },
    },
    polish: {
        languageName: 'Polskie',
        languageCode: 'pl',
        quotes: { start: '„', end: '”' },
    },
    portuguese: {
        languageName: 'Português',
        languageCode: 'pt',
        quotes: { start: '«', end: '»' },
    },
    romanian: {
        languageName: 'Română',
        languageCode: 'ro',
        quotes: { start: '„', end: '”' },
    },
    serbian: {
        languageName: 'Српски',
        languageCode: 'sr',
        quotes: { start: '„', end: '”' },
    },
    slovak: {
        languageName: 'Slovenčina',
        languageCode: 'sk',
        quotes: { start: '„', end: '“' },
    },
    spanish: {
        languageName: 'Español',
        languageCode: 'es',
        quotes: { start: '«', end: '»' },
    },
    swedish: {
        languageName: 'Svenska',
        languageCode: 'sv',
        quotes: { start: '”', end: '”' },
    },
};
exports.languages = languages;
/**
 * All available countries in the BEMER universe.
 *
 * THE ORDER OF THE LANGUAGES ARRAY MATTERS!
 * The first language in the languages array is the default language of that country.
 */
var allCountries = {
    austria: {
        countryName: 'Österreich',
        countryCode: 'AT',
        icon: '🇦🇹',
        currency: currencies.EUR,
        languages: [languages.german, languages.english],
    },
    belgium: {
        countryName: 'België',
        countryCode: 'BE',
        icon: '🇧🇪',
        currency: currencies.EUR,
        languages: [
            languages.german,
            languages.dutch,
            languages.french,
            languages.english,
        ],
    },
    brazil: {
        countryName: 'Brasil',
        countryCode: 'BR',
        icon: '🇧🇷',
        currency: currencies.BRL,
        languages: [languages.portuguese, languages.english],
    },
    canada: {
        countryName: 'Canada',
        countryCode: 'CA',
        icon: '🇨🇦',
        currency: currencies.CAD,
        languages: [languages.english, languages.french],
    },
    czechRepublic: {
        countryName: 'Česká republika',
        countryCode: 'CZ',
        icon: '🇨🇿',
        currency: currencies.CZK,
        languages: [languages.czech, languages.english],
    },
    denmark: {
        countryName: 'Danmark',
        countryCode: 'DK',
        icon: '🇩🇰',
        currency: currencies.DKK,
        languages: [languages.danish, languages.english],
    },
    finland: {
        countryName: 'Suomi',
        countryCode: 'FI',
        icon: '🇫🇮',
        currency: currencies.EUR,
        languages: [languages.finnish, languages.english],
    },
    france: {
        countryName: 'France',
        countryCode: 'FR',
        icon: '🇫🇷',
        currency: currencies.EUR,
        languages: [languages.french, languages.english],
    },
    germany: {
        countryName: 'Deutschland',
        countryCode: 'DE',
        icon: '🇩🇪',
        currency: currencies.EUR,
        languages: [languages.german, languages.english],
    },
    unitedKingdom: {
        countryName: 'United Kingdom',
        countryCode: 'GB',
        icon: '🇬🇧',
        currency: currencies.GBP,
        languages: [languages.english],
    },
    hungary: {
        countryName: 'Magyarország',
        countryCode: 'HU',
        icon: '🇭🇺',
        currency: currencies.HUF,
        languages: [languages.hungary, languages.english],
    },
    ireland: {
        countryName: 'Éireann',
        countryCode: 'IE',
        icon: '🇮🇪',
        currency: currencies.EUR,
        languages: [languages.english],
    },
    italy: {
        countryName: 'Italia',
        countryCode: 'IT',
        icon: '🇮🇹',
        currency: currencies.EUR,
        languages: [languages.italian, languages.english],
    },
    liechtenstein: {
        countryName: 'Liechtenstein',
        countryCode: 'LI',
        icon: '🇱🇮',
        currency: currencies.CHF,
        languages: [languages.german, languages.english],
    },
    lithuania: {
        countryName: 'Lietuva',
        countryCode: 'LT',
        icon: '🇱🇹',
        currency: currencies.EUR,
        languages: [languages.lithuanian, languages.english],
    },
    luxembourg: {
        countryName: 'Luxembourg',
        countryCode: 'LU',
        icon: '🇱🇺',
        currency: currencies.EUR,
        languages: [languages.german, languages.french, languages.english],
    },
    malaysia: {
        countryName: 'မလေးရှား',
        countryCode: 'MY',
        icon: '🇲🇾',
        currency: currencies.MYR,
        languages: [languages.malay, languages.english],
    },
    netherlands: {
        countryName: 'Nederland',
        countryCode: 'NL',
        icon: '🇳🇱',
        currency: currencies.EUR,
        languages: [languages.dutch, languages.english],
    },
    norway: {
        countryName: 'Norge',
        countryCode: 'NO',
        icon: '🇳🇴',
        currency: currencies.NOK,
        languages: [languages.norwegian, languages.english],
    },
    poland: {
        countryName: 'Polska',
        countryCode: 'PL',
        icon: '🇵🇱',
        currency: currencies.PLN,
        languages: [languages.polish, languages.english],
    },
    romania: {
        countryName: 'România',
        countryCode: 'RO',
        icon: '🇷🇴',
        currency: currencies.RON,
        languages: [languages.romanian, languages.english],
    },
    serbia: {
        countryName: 'Србија',
        countryCode: 'RS',
        icon: '🇷🇸',
        currency: currencies.RSD,
        languages: [languages.serbian, languages.english],
    },
    slovakia: {
        countryName: 'Slovensko',
        countryCode: 'SK',
        icon: '🇸🇰',
        currency: currencies.EUR,
        languages: [languages.slovak, languages.english],
    },
    southAfrica: {
        countryName: 'South Africa',
        countryCode: 'ZA',
        icon: '🇿🇦',
        currency: currencies.ZAR,
        languages: [languages.english],
    },
    spain: {
        countryName: 'España',
        countryCode: 'ES',
        icon: '🇪🇸',
        currency: currencies.EUR,
        languages: [languages.spanish, languages.english],
    },
    sweden: {
        countryName: 'Sverige',
        countryCode: 'SE',
        icon: '🇸🇪',
        currency: currencies.SEK,
        languages: [languages.swedish, languages.english],
    },
    switzerland: {
        countryName: 'Schweiz',
        countryCode: 'CH',
        icon: '🇨🇭',
        currency: currencies.CHF,
        languages: [
            languages.german,
            languages.italian,
            languages.french,
            languages.english,
        ],
    },
    taiwan: {
        countryName: '台湾',
        countryCode: 'TW',
        icon: '🇹🇼',
        currency: currencies.TWD,
        languages: [languages.mandarin, languages.english],
    },
    unitedStates: {
        countryName: 'United States',
        countryCode: 'US',
        icon: '🇺🇸',
        currency: currencies.USD,
        languages: [languages.english, languages.spanish],
    },
};
exports.allCountries = allCountries;
/**
 * All available regions in the BEMER universe.
 */
var regions = {
    europe: {
        regionCode: 'EUROPE',
        regionName: 'Europe',
        icon: '🇪🇺',
        globeIcon: '🌍',
        countries: [
            allCountries.austria,
            allCountries.belgium,
            allCountries.czechRepublic,
            allCountries.denmark,
            allCountries.finland,
            allCountries.france,
            allCountries.germany,
            allCountries.hungary,
            allCountries.ireland,
            allCountries.liechtenstein,
            allCountries.lithuania,
            allCountries.luxembourg,
            allCountries.netherlands,
            allCountries.norway,
            allCountries.poland,
            allCountries.slovakia,
            allCountries.spain,
            allCountries.sweden,
            allCountries.switzerland,
            allCountries.unitedKingdom,
        ],
    },
    canada: {
        regionCode: 'CANADA',
        regionName: 'Canada',
        icon: '🍁',
        globeIcon: '🌎',
        countries: [allCountries.canada],
    },
    usa: {
        regionCode: 'USA',
        regionName: 'USA',
        icon: '🗽',
        globeIcon: '🌎',
        countries: [allCountries.unitedStates],
    },
    italy: {
        regionCode: 'ITALY',
        regionName: 'Italy',
        icon: '🛵',
        globeIcon: '🌍',
        countries: [allCountries.italy, allCountries.serbia, allCountries.romania],
    },
    world: {
        regionCode: 'WORLD',
        regionName: 'World',
        icon: '🗺',
        globeIcon: '🌏',
        countries: [
            allCountries.southAfrica,
            allCountries.malaysia,
            allCountries.taiwan,
            allCountries.brazil,
        ],
    },
};
exports.regions = regions;
var generatedQuotes = {};
(0, getObjectKeys_1.getObjectKeys)(allCountries).forEach(function (countryKey) {
    var c = allCountries[countryKey];
    c.languages.forEach(function (language) {
        generatedQuotes["".concat(language.languageCode, "_").concat(c.countryCode)] =
            language.quotes;
    });
});
/**
 * The exported quotes map including some country specific overwrites.
 */
var quotesMap = __assign(__assign({}, generatedQuotes), { pt_BR: { start: '“', end: '”' }, en_GB: { start: '‘', end: '’' }, de_CH: { start: '«', end: '»' }, en_CH: { start: '«', end: '»' } });
exports.quotesMap = quotesMap;
